import SelectGroup from './SelectGroup.view';

export default SelectGroup;
